import i18n from '../lang'

export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavTitle',
        _children: [i18n.t('menu.concursos')]
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('concursos.nuevo'),
        to: '/concursos/crear',
        icon: 'cil-pencil'
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('concursos.consultar'),
        to: '/concursos/lista',
        icon: 'cil-list'
      },


      {
        _name: 'CSidebarNavTitle',
        _children: [i18n.t('menu.lotes')]
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('lotes.consultar'),
        to: '/lotes/lista',
        icon: 'cil-list'
      },


      {
        _name: 'CSidebarNavTitle',
        _children: [i18n.t('menu.ofertas')]
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('ofertas.nuevo'),
        to: '/ofertas/crear',
        icon: 'cil-pencil'
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('ofertas.consultar'),
        to: '/ofertas/lista',
        icon: 'cil-list'
      },


      {
        _name: 'CSidebarNavTitle',
        _children: [i18n.t('menu.licitadores')]
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('licitadores.nuevo'),
        to: '/licitadores/crear',
        icon: 'cil-pencil'
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('licitadores.consultar'),
        to: '/licitadores/lista',
        icon: 'cil-list'
      },

      {
        _name: 'CSidebarNavTitle',
        _children: [i18n.t('menu.informes')]
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('informes.nuevo'),
        to: '/informes/nuevo',
        icon: 'cil-pencil'
      },
    ]
  }
]